var map = {
	"./de/kv.jpg": "2zHj",
	"./en/kv.jpg": "YhN7",
	"./es/kv.jpg": "AKwE",
	"./fr/kv.jpg": "Vv9m",
	"./ja/kv.jpg": "3kKV",
	"./ko/kv.jpg": "Vqyt",
	"./pt/kv.jpg": "q6jg",
	"./ru/kv.jpg": "r2dw",
	"./th/kv.jpg": "RN86",
	"./zh-Hant/kv.jpg": "DeOP"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "81TY";